import { AppStateValue } from "../../AppState";
import { getCachedUsers } from "../cache/PlatformUserCache";
import { platformService } from "../services/platform.service";
import { FILTERS_STRINGS } from "./constants";

const api = new platformService();

const checkData = (id: number, cachedData: any[]) => cachedData?.find(x => x.Id === id);

export const retrieveStatus = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? (await api.getStatus(`(${id})`))?.data;
export const retrieveCategory = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? (await api.getCategories(`(${id})`))?.data;
export const retrievePriority = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? (await api.getPriority(`(${id})`))?.data;
export const retrieveUser = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? (await api.getPlatformUser(id))?.data;
export const retrieveTeam = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? await api.getTeamSafe(id);
export const retrieveSupportGroup = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? (await api.getSupportGroups(`(${id})`))?.data;
export const retrieveTicketType = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? await api.getTicketTypeSafe(id);
export const retrieveSource = async (id: number, cachedData: any[]) => checkData(id, cachedData) ?? (await api.getSource(`(${id})`))?.data;
export const retrieveResolution = async (id: number, cachedData: any) => checkData(id, cachedData) ?? (await api.getResolution(`(${id})?$expand=ResolutionCategory`))?.data;

export const retrieveTicketInformation = async (data: any, currentState: AppStateValue, isForm: boolean, isEndUser?: boolean) => {
  isEndUser ??= false;

  const uids = [data.AssigneeId, data.RequesterId, ...(data.AffectedUsers?.map(x => x.PlatformUserId) ?? []), ...(data.TicketCollaborators?.map(x => x.PlatformUserId) ?? [])].filter(x => x != null && x != undefined);

  const [users, slasResult, lifecycleResult, groupChatResult] = await Promise.all([
    getCachedUsers(uids),
    api.getTicket(data.Id, FILTERS_STRINGS.TICKET_SLA_EXPAND),
    data.TicketLifecycleId ? api.getTicket(data.Id, FILTERS_STRINGS.TICKET_LIFECYCLE_EXPAND) : Promise.resolve(null),
    data.GroupChatId ? api.getTicket(data.Id, FILTERS_STRINGS.TICKET_GROUP_CHAT_EXPAND) : Promise.resolve(null),
  ]);

  data.TicketSlas = slasResult?.data?.TicketSlas ?? [];
  if (lifecycleResult?.data?.TicketLifecycle) data.TicketLifecycle = lifecycleResult.data.TicketLifecycle;
  if (groupChatResult?.data?.GroupChat) data.GroupChat = groupChatResult.data.GroupChat;

  if (!isEndUser) {
    if (data.StatusId)
      data.Status = await retrieveStatus(data.StatusId, currentState.ticketStatus);
    if (data.CategoryId)
      data.Category = await retrieveCategory(data.CategoryId, currentState.categories);
    if (data.PriorityId)
      data.Priority = await retrievePriority(data.PriorityId, currentState.priority);
    if (data.SourceId)
      data.Source = await retrieveSource(data.SourceId, currentState.source);
    if (data.TeamId)
      data.Team = await retrieveTeam(data.TeamId, currentState.teams);
    if (data.SupportGroupId)
      data.SupportGroup = await retrieveSupportGroup(data.SupportGroupId, currentState.supportgroups);
    if (data.TicketTypeId)
      data.TicketType = await retrieveTicketType(data.TicketTypeId, currentState.ticketTypes);

    if (isForm && data.ResolutionId)
      data.Resolution = await retrieveResolution(data.ResolutionId, currentState.resolution);
  }

  if (data.AssigneeId)
    data.Assignee = users.find(u => u.Id == data.AssigneeId);
  if (data.RequesterId)
    data.Requester = users.find(u => u.Id == data.RequesterId);

  if (data.AffectedUsers?.length > 0)
    data.AffectedUsers?.forEach(u => u.PlatformUser = users.find(i => i.Id == u.PlatformUserId));
  if (data.TicketCollaborators?.length > 0)
    data.TicketCollaborators?.forEach(t => t.PlatformUser = users.find(i => i.Id == t.PlatformUserId));

  return data;
};